import searchBoxTpl from './search-box.tpl.html!text';
import watch from 'redux-watch';

class SearchBoxCtrl {
    constructor($scope, $element, $state, $stateParams, $timeout, storeServ, searchServ, helperServ) {
        this.$scope = $scope;
        this.$element = $element;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.storeServ = storeServ;
        this.searchServ = searchServ;
        this.helperServ = helperServ;

        this.spinners = { geolocation: false };
        this.timeouts = [];

        this.ngOnInit();
    }

    ngOnInit() {
        this.geolocationSupport = this.helperServ.checkForGeolocationSupport();

        this.initSearchBox();
        
        (this.geolocateOnMapReady && this.geolocationSupport) && this.subscribeToStore();

        this.searchBox.addListener('places_changed', this.onPlacesChanged.bind(this));
                
        this.$scope.$on('$destroy', this.ngOnDestroy.bind(this));
    }

    initSearchBox() {
        this.input = this.$element.find('#search-field')[0];

        this.searchBox = new google.maps.places.SearchBox(this.input, this.searchServ.readSearchBoxConfig().searchBox);
    }

    subscribeToStore() {
        let watchMapReady = watch(this.storeServ.getState, 'mapReady');
        let watchMapBounds = watch(this.storeServ.getState, 'mapBounds');

        this.stopWatchingMapReady = this.storeServ.subscribe(watchMapReady((mapReady, oldVal, objectPath) => {
            mapReady && this.geolocate();
        }));

        this.stopWatchingMapBounds = this.storeServ.subscribe(watchMapBounds((newMapBounds, oldMapBounds, objectPath) => {
            newMapBounds && this.setBounds(newMapBounds);
        }));
    }

    onPlacesChanged() {
        var place = this.searchBox.getPlaces()[0];

        if (angular.isObject(place) && place.geometry) {

            this.storeServ.dispatch({
                type: 'SET_SEARCHED_PLACE_COORDINATES',
                searchedPlaceCoordinates: null
            });

            this.storeServ.dispatch({
                type: 'SET_SEARCHED_PLACE_COORDINATES',
                searchedPlaceCoordinates: {
                    location: {
                        lat: place.geometry.location.lat(),
                        lng: place.geometry.location.lng()
                    },
                    viewport: this.helperServ.getLiteralBounds(place.geometry.viewport)
                }
            });
        } else {
            this.placeNotFound();
        }
    }

    setBounds(bounds) {
        this.searchBox.setBounds(new google.maps.LatLngBounds(
            new google.maps.LatLng(bounds.southWestLat, bounds.southWestLng),
            new google.maps.LatLng(bounds.northEastLat, bounds.northEastLng)
        ));
    }

    simulateSearch() {
        if (this.$scope.searchBoxForm.$valid) {
            google.maps.event.trigger(this.input, 'focus');
            google.maps.event.trigger(this.input, 'keydown', {
                keyCode: 13
            });
            google.maps.event.trigger(this.input, 'blur');
        }
    }

    placeNotFound() {
        this.$scope.$evalAsync(() => {
            this.$scope.searchBoxForm.searchField.$setValidity('couldNotFindPlace', false);
        });
    }

    clearSubmitErrors() {
        this.$scope.searchBoxForm.searchField.$setValidity('couldNotFindPlace', true);
    }

    clearSearchBoxForm() {
        google.maps.event.trigger(this.input, 'blur');
        this.$scope.searchField = '';
        this.$scope.searchBoxForm.$setPristine();
        this.$scope.searchBoxForm.$setUntouched();
    }

    geolocate() {
        if (!this.spinners.geolocation) {

            this.clearSearchBoxForm();

            this.spinners.geolocation = true;

            navigator.geolocation.getCurrentPosition((position) => {

                this.storeServ.dispatch({
                    type: 'SET_SEARCHED_PLACE_COORDINATES',
                    searchedPlaceCoordinates: null
                });

                this.storeServ.dispatch({
                    type: 'SET_SEARCHED_PLACE_COORDINATES',
                    searchedPlaceCoordinates: {
                        location: {
                            lat: position.coords.latitude,
                            lng: position.coords.longitude
                        },
                        viewport: null
                    }
                });

                this.$scope.$evalAsync(() => {
                    this.spinners.geolocation = false;
                });

            }, () => {

                this.$scope.$evalAsync(() => {
                    this.spinners.geolocation = false;
                    this.geolocationDenied = true;
                });

                let timeout = this.$timeout(() => {
                    this.geolocationDenied = false;
                }, 3000);

                this.timeouts.push(timeout);
            });
        }
    }

    ngOnDestroy() {
        (this.geolocateOnMapReady && this.geolocationSupport) && this.stopWatchingMapReady();

        this.helperServ.cancelTimeouts(this.timeouts, this.$timeout);
        
        this.storeServ.getState().searchedPlaceCoordinates && this.storeServ.dispatch({
            type: 'SET_SEARCHED_PLACE_COORDINATES',
            searchedPlaceCoordinates: null
        });
    }
}

SearchBoxCtrl.$inject = ['$scope', '$element', '$state', '$stateParams', '$timeout', 'storeServ', 'searchServ', 'helperServ'];

var searchBox = function() {
 	return {
 		restrict: 'E',
 		replace: true,
 		transclude: true,
 		template: searchBoxTpl,
 		scope: {},
 		controller: SearchBoxCtrl,
 		controllerAs: 'ctrl',
 		bindToController: {
 			geolocateOnMapReady: '='
 		}
 	};
 };

 export default searchBox;